import { createTheme } from '@mui/material/styles'

/**
 * Construction management, not a consumer app: dense tables, high contrast, no decoration.
 * The palette is deliberately restrained so that status colours carry all the meaning.
 */
export const theme = createTheme({
  palette: {
    primary: { main: '#0f3d5c', light: '#3a6584', dark: '#06263c', contrastText: '#ffffff' },
    secondary: { main: '#c2571c', contrastText: '#ffffff' },
    success: { main: '#1b7f4b' },
    warning: { main: '#b46b04' },
    error: { main: '#b3261e' },
    info: { main: '#1f6feb' },
    background: { default: '#f4f6f8', paper: '#ffffff' },
    text: { primary: '#131c24', secondary: '#4a5a68' },
    divider: '#dbe2e8',
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    h4: { fontWeight: 700, fontSize: '1.5rem' },
    h5: { fontWeight: 700, fontSize: '1.2rem' },
    h6: { fontWeight: 600, fontSize: '1.05rem' },
    subtitle2: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { paddingTop: 10, paddingBottom: 10 },
        head: { fontWeight: 700, whiteSpace: 'nowrap', backgroundColor: '#eef2f5' },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small' },
    },
    MuiSelect: {
      defaultProps: { size: 'small' },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
  },
})
